import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    minSize: { type: Number, default: 1.5 },
    maxSize: { type: Number, default: 3 },
    maxLength: { type: Number, default: 50 }
  }

  connect() {
    this.adjustFontSize()
    this.resizeObserver = new ResizeObserver(() => this.adjustFontSize())
    this.resizeObserver.observe(this.element.parentElement)
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  adjustFontSize() {
    const text = this.element.textContent.trim()
    const length = text.length

    // Calculate size based on text length
    // Short titles get larger font, long titles get smaller
    const ratio = Math.min(length / this.maxLengthValue, 1)
    const sizeRange = this.maxSizeValue - this.minSizeValue
    const fontSize = this.maxSizeValue - (ratio * sizeRange)

    this.element.style.fontSize = `${fontSize}rem`
  }
}
